import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getBingoDefinitionsList(params: any, fullResponse?: boolean) {
  let res = [
    {
      gameId: "",
      lobbyOrdering: "",
      manufacturer: "",
      title: "",
      wager: "",
      payout: "",
      active: "",
      bingoDefinitionId: "",
      bingoPrizeId: "",
      slotDefinitionId: "",
      checksum: "",
      packageChecksum: ""
    }
  ]
  if (params) {
    params = removeEmpty(params)
  }
  await Api.get(endpoints.getBingoDefinitionsList, { params }).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Error on getting bingo definitions')
  })

  return res
}

export async function getBingoDefinitionDetails(params: any) {

  let res: any = {
    definition: {},
    prizes:{},
    slots:{}
  }
  await Api.get(endpoints.getBingoDefinitionsDetail, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get bingo game details')
    }
  }).catch((err: string) => {
    notificationError('Could not get bingo game details')
  })

  return res
}


export async function deleteBingoGameById(params: any){
  let res = false
  await Api.get(endpoints.deleteBingoGameById, {params}).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
            res = true
            notificationSucces('Bingo game deleted successfully')
        }
    }
  }).catch((err: string) => {
      notificationError('Could not delete the bingo game')
  })
  return res
}